module.exports = __webpack_public_path__ + "img/suggestIcon.409a17f1.png";